export default "__VITE_ASSET__DVb6kDhb__"